import { render, staticRenderFns } from "./ValidateSuccess.vue?vue&type=template&id=27c9fe7f&scoped=true"
import script from "./ValidateSuccess.vue?vue&type=script&lang=js"
export * from "./ValidateSuccess.vue?vue&type=script&lang=js"
import style0 from "./ValidateSuccess.vue?vue&type=style&index=0&id=27c9fe7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9fe7f",
  null
  
)

export default component.exports